"use strict";

export function cargarMenu() {


    // =====================================================
    // ELEMENTO PRINCIPAL DEL MENÚ
    // =====================================================

    const menu =
        document.getElementById("menu");


    if (!menu) {

        return;

    }


    // =====================================================
    // VERIFICAR SESIÓN
    // =====================================================

    let usuarioSesion = null;


    try {

        const sesion =
            sessionStorage.getItem(
                "usuarioSesion"
            );


        if (sesion) {

            usuarioSesion =
                JSON.parse(sesion);

        }

    }

    catch (error) {

        console.error(
            "ERROR AL LEER LA SESIÓN:",
            error
        );


        usuarioSesion = null;

    }


    // =====================================================
    // SI NO EXISTE SESIÓN
    // =====================================================

    if (!usuarioSesion) {

        window.location.replace(
            "/inicioSesion.html"
        );


        return;

    }


    // =====================================================
    // OBTENER ROL
    // =====================================================

    const rolUsuario =
        usuarioSesion.NOMBREROL
            ? usuarioSesion.NOMBREROL
            : "";


    console.log(
        "ROL DEL USUARIO:",
        rolUsuario
    );


    // =====================================================
    // NORMALIZAR ROL
    // =====================================================

    const rol =
        rolUsuario
            .toString()
            .trim()
            .toUpperCase();


    // =====================================================
    // DETERMINAR ROLES
    // =====================================================

    const esRRHH =
        rol === "RRHH";


    const esAdministrador =
        rol === "ADMINISTRADOR";


    const esFinanzas =
        rol === "FINANZAS";


    const esProduccion =
        rol === "PRODUCCION";


    const esMercadeo =
        rol === "MERCADEO";


    const esLogistica =
        rol === "LOGISTICA";


    // =====================================================
    // MOSTRAR ROLES EN CONSOLA
    // =====================================================

    console.log(
        "ES RRHH:",
        esRRHH
    );


    console.log(
        "ES ADMINISTRADOR:",
        esAdministrador
    );


    console.log(
        "ES FINANZAS:",
        esFinanzas
    );


    console.log(
        "ES PRODUCCION:",
        esProduccion
    );


    console.log(
        "ES MERCADEO:",
        esMercadeo
    );


    console.log(
        "ES LOGISTICA:",
        esLogistica
    );


    // =====================================================
    // VALIDAR ROL
    // =====================================================

    if (

        !esRRHH &&
        !esAdministrador &&
        !esFinanzas &&
        !esProduccion &&
        !esMercadeo &&
        !esLogistica

    ) {

        console.error(
            "ROL NO AUTORIZADO:",
            rolUsuario
        );


        sessionStorage.clear();


        window.location.replace(
            "/inicioSesion.html"
        );


        return;

    }


    // =====================================================
    // HTML DEL MENÚ
    // =====================================================

    menu.innerHTML = `


        <!-- =====================================================
             BOTÓN RESPONSIVE
        ====================================================== -->

        <button
            type="button"
            id="btnMenu"
            class="btn-menu"
            aria-label="Abrir menú lateral"
            title="Abrir menú">

            <i class="bi bi-list"></i>

        </button>



        <!-- =====================================================
             OVERLAY
        ====================================================== -->

        <div
            class="overlay"
            id="overlay">
        </div>



        <!-- =====================================================
             SIDEBAR
        ====================================================== -->

        <div
            class="sidebar"
            id="sidebar">


            <!-- =================================================
                 LOGO
            ================================================== -->

            <div class="logo">

                <i class="bi bi-buildings-fill"></i>

                <h4>
                    Consulting S.A.
                </h4>

                <small>
                    Sistema de Nóminas
                </small>

            </div>
   <!-- =================================================
                 SISTEMA
            ================================================== -->

            <div class="menu-title">

                Sistema

            </div>

            <ul class="nav flex-column">


                <!-- CERRAR SESIÓN -->

                <li>

                    <a
                        href="/inicioSesion.html"
                        class="nav-link"
                        id="btnCerrarSesion">

                        <i class="bi bi-box-arrow-right"></i>

                        Cerrar Sesión

                    </a>

                </li>


            </ul>


            <!-- =================================================
                 ADMINISTRACIÓN
            ================================================== -->

            <div class="menu-title">

                Administración

            </div>


            <ul class="nav flex-column">


                <!-- =============================================
                     CONTRATACIÓN
                ============================================== -->

                <li>

                    <a
                        href="#contratacionMenu"
                        class="nav-link menu-toggle modulo-restringido"
                        data-modulo="Contratación">

                        <i class="bi bi-person-vcard"></i>

                        CONTRATACIÓN

                        <i class="bi bi-chevron-down"></i>

                    </a>


                    <div
                        class="submenu"
                        id="contratacionMenu">


                        <!-- EMPLEADO -->

                        <a
                            href="/empleados.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Empleado">

                            <i class="bi bi-person-plus"></i>

                            EMPLEADO

                        </a>


                        <!-- SALARIO BASE -->

                        <a
                            href="/salario.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Salario Base">

                            <i class="bi bi-cash-stack"></i>

                            <span>
                                SALARIO BASE
                            </span>

                        </a>


                        <!-- DEPARTAMENTO -->

                        <a
                            href="/departamento.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Departamento">

                            <i class="bi bi-diagram-3-fill"></i>

                            <span>
                                DEPARTAMENTO
                            </span>

                        </a>


                    </div>

                </li>


            </ul>



            <!-- =================================================
                 SEGURIDAD
            ================================================== -->

            <div class="menu-title">

                Seguridad

            </div>


            <ul class="nav flex-column">


                <li>

                    <a
                        href="#seguridadMenu"
                        class="nav-link menu-toggle modulo-restringido"
                        data-modulo="Seguridad">

                        <i class="bi bi-shield-lock-fill"></i>

                        Seguridad

                        <i class="bi bi-chevron-down"></i>

                    </a>


                    <div
                        class="submenu"
                        id="seguridadMenu">


                        <!-- USUARIO -->

                        <a
                            href="/usuario.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Usuarios">

                            <i class="bi bi-person-lock"></i>

                            USUARIO

                        </a>


                        <!-- ACCESO -->

                        <a
                            href="/acceso.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Acceso">

                            <i class="bi bi-key-fill"></i>

                            ACCESO

                        </a>


                    </div>

                </li>


            </ul>



            <!-- =================================================
                 NÓMINA
            ================================================== -->

            <div class="menu-title">

                Nómina

            </div>


            <ul class="nav flex-column">


                <!-- =============================================
                     ANTICIPOS
                ============================================== -->

                <li>

                    <a
                        href="/anticipo.html"
                        class="nav-link modulo-restringido"
                        data-modulo="Anticipos">

                        <i class="bi bi-calendar-check-fill"></i>

                        Anticipos

                    </a>

                </li>



                <!-- =============================================
                     INGRESOS
                ============================================== -->

                <li>

                    <a
                        href="#ingresosMenu"
                        class="nav-link menu-toggle"
                        data-modulo="Ingresos">

                        <i class="bi bi-cash-stack"></i>

                        Ingresos

                        <i class="bi bi-chevron-down"></i>

                    </a>


                    <div
                        class="submenu"
                        id="ingresosMenu">


                        <!-- HORAS EXTRAS -->

                        <a
                            href="/hrsextra.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Horas Extras">

                            <i class="bi bi-clock-history"></i>

                            Horas Extras

                        </a>



                        <!-- HORAS DOBLES -->

                        <a
                            href="/dobles.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Horas Dobles">

                            <i class="bi bi-clock-fill"></i>

                            Horas Dobles

                        </a>



                        <!-- BONIFICACIÓN DECRETO -->

                        <a
                            href="/decreto.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Bonificación Decreto">

                            <i class="bi bi-gift-fill"></i>

                            Bonificación Decreto

                        </a>



                        <!-- BONIFICACIÓN PRODUCCIÓN -->

                        <a
                            href="/produccion.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Bonificación Producción">

                            <i class="bi bi-graph-up-arrow"></i>

                            Bonificación Producción

                        </a>



                        <!-- COMISIONES -->

                        <a
                            href="/comisiones.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Comisiones">

                            <i class="bi bi-currency-dollar"></i>

                            Comisiones

                        </a>


                    </div>

                </li>



                <!-- =============================================
                     EGRESOS
                ============================================== -->

                <li>

                    <a
                        href="#egresosMenu"
                        class="nav-link menu-toggle modulo-restringido"
                        data-modulo="Egresos">

                        <i class="bi bi-cash-coin"></i>

                        Egresos

                        <i class="bi bi-chevron-down"></i>

                    </a>


                    <div
                        class="submenu"
                        id="egresosMenu">


                        <!-- IGSS -->

                        <a
                            href="/igss.html"
                            class="nav-link modulo-restringido"
                            data-modulo="IGSS">

                            <i class="bi bi-hospital"></i>

                            IGSS

                        </a>



                        <!-- ISR -->

                        <a
                            href="/isr.html"
                            class="nav-link modulo-restringido"
                            data-modulo="ISR">

                            <i class="bi bi-file-earmark-text"></i>

                            ISR

                        </a>



                        <!-- ASOCIACIÓN SOLIDARISTA -->

                        <a
                            href="/asociacion.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Asociación Solidarista">

                            <i class="bi bi-piggy-bank-fill"></i>

                            Asociación Solidarista

                        </a>



                        <!-- DESCUENTOS TIENDA -->

                        <a
                            href="/tienda.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Descuentos Tienda">

                            <i class="bi bi-cart-fill"></i>

                            Descuentos Tienda

                        </a>


                    </div>

                </li>



                <!-- =============================================
                     PROCESAR NÓMINA
                ============================================== -->

                <li>

                    <a
                        href="/procesar.html"
                        class="nav-link modulo-restringido"
                        data-modulo="Procesar Nómina">

                        <i class="bi bi-calculator-fill"></i>

                        Procesar Nómina

                    </a>

                </li>


            </ul>



            <!-- =================================================
                 CONSULTAS Y REPORTES
            ================================================== -->

            <div class="menu-title">

                Consultas y Reportes

            </div>


            <ul class="nav flex-column">


                <li>

                    <a
                        href="#reportesMenu"
                        class="nav-link menu-toggle"
                        data-modulo="Reportes">

                        <i class="bi bi-bar-chart-fill"></i>

                        Reportes

                        <i class="bi bi-chevron-down"></i>

                    </a>


                    <div
                        class="submenu"
                        id="reportesMenu">


                        <!-- CUMPLEAÑEROS -->

                        <a
                            href="/cumple.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Cumpleañeros">

                            <i class="bi bi-cake2-fill"></i>

                            Cumpleañeros

                        </a>



                        <!-- DESCUENTOS IGSS -->

                        <a
                            href="/reportesigss.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Descuentos IGSS">

                            <i class="bi bi-shield-plus"></i>

                            Descuentos IGSS

                        </a>



                        <!-- DESCUENTOS ISR -->

                        <a
                            href="/reportesIsr.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Descuentos ISR">

                            <i class="bi bi-file-earmark-ruled-fill"></i>

                            Descuentos ISR

                        </a>



                        <!-- PÓLIZA CONTABLE -->

                        <a
                            href="/poliza.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Póliza Contable">

                            <i class="bi bi-journal-text"></i>

                            Póliza Contable

                        </a>



                        <!-- LIBRO DE SALARIOS -->

                        <a
                            href="/libro.html"
                            class="nav-link modulo-restringido"
                            data-modulo="Libro de Salarios">

                            <i class="bi bi-book-fill"></i>

                            Libro de Salarios

                        </a>


                    </div>

                </li>


            </ul>



         




        </div>

    `;


    // ==========================================================
    // ELEMENTOS
    // ==========================================================

    const btnMenu =
        document.getElementById(
            "btnMenu"
        );


    const sidebar =
        document.getElementById(
            "sidebar"
        );


    const overlay =
        document.getElementById(
            "overlay"
        );


    // ==========================================================
    // BLOQUEAR MÓDULOS SEGÚN ROL
    // ==========================================================

    if (

        esRRHH ||
        esFinanzas ||
        esProduccion ||
        esMercadeo ||
        esLogistica

    ) {


        const modulos =
            document.querySelectorAll(
                ".modulo-restringido"
            );


        modulos.forEach(
            function (modulo) {


                // ==================================================
                // OBTENER NOMBRE DEL MÓDULO
                // ==================================================

                const nombreModulo =
                    modulo.dataset.modulo
                        ? modulo.dataset.modulo
                        : "";


                const nombreNormalizado =
                    nombreModulo
                        .toString()
                        .trim()
                        .toUpperCase();


                // ==================================================
                // POR DEFECTO:
                //
                // BLOQUEADO
                // ==================================================

                let permitido = false;



                // ==================================================
                // RRHH
                //
                // ACCESO COMPLETO A:
                //
                // CONTRATACIÓN
                // NÓMINA
                // INGRESOS
                // EGRESOS
                // REPORTES
                // ==================================================

                if (esRRHH) {

                    if (

                        // CONTRATACIÓN

                        nombreNormalizado ===
                            "CONTRATACIÓN" ||

                        nombreNormalizado ===
                            "EMPLEADO" ||

                        nombreNormalizado ===
                            "SALARIO BASE" ||

                        nombreNormalizado ===
                            "DEPARTAMENTO" ||


                        // NÓMINA

                        nombreNormalizado ===
                            "ANTICIPOS" ||

                        nombreNormalizado ===
                            "PROCESAR NÓMINA" ||


                        // INGRESOS

                        nombreNormalizado ===
                            "HORAS EXTRAS" ||

                        nombreNormalizado ===
                            "HORAS DOBLES" ||

                        nombreNormalizado ===
                            "BONIFICACIÓN DECRETO" ||

                        nombreNormalizado ===
                            "BONIFICACIÓN PRODUCCIÓN" ||

                        nombreNormalizado ===
                            "COMISIONES" ||


                        // EGRESOS

                        nombreNormalizado ===
                            "EGRESOS" ||

                        nombreNormalizado ===
                            "IGSS" ||

                        nombreNormalizado ===
                            "ISR" ||

                        nombreNormalizado ===
                            "ASOCIACIÓN SOLIDARISTA" ||

                        nombreNormalizado ===
                            "DESCUENTOS TIENDA" ||


                        // REPORTES

                        nombreNormalizado ===
                            "CUMPLEAÑEROS" ||

                        nombreNormalizado ===
                            "DESCUENTOS IGSS" ||

                        nombreNormalizado ===
                            "DESCUENTOS ISR" ||

                        nombreNormalizado ===
                            "PÓLIZA CONTABLE" ||

                        nombreNormalizado ===
                            "LIBRO DE SALARIOS"

                    ) {

                        permitido = true;

                    }

                }



                // ==================================================
                // FINANZAS
                //
                // PERMITIDO ÚNICAMENTE:
                //
                // - PÓLIZA CONTABLE
                //
                // NO PERMITIDO:
                //
                // - ANTICIPOS
                // - PROCESAR NÓMINA
                // ==================================================

                if (esFinanzas) {

                    if (

                        nombreNormalizado ===
                            "PÓLIZA CONTABLE"

                    ) {

                        permitido = true;

                    }

                }



                // ==================================================
                // PRODUCCION
                //
                // PERMITIDO:
                //
                // - HORAS EXTRAS
                // - HORAS DOBLES
                // - BONIFICACIÓN PRODUCCIÓN
                // ==================================================

                if (esProduccion) {

                    if (

                        nombreNormalizado ===
                            "HORAS EXTRAS" ||

                        nombreNormalizado ===
                            "HORAS DOBLES" ||

                        nombreNormalizado ===
                            "BONIFICACIÓN PRODUCCIÓN"

                    ) {

                        permitido = true;

                    }

                }



                // ==================================================
                // MERCADEO
                //
                // PERMITIDO:
                //
                // - COMISIONES
                // ==================================================

                if (esMercadeo) {

                    if (

                        nombreNormalizado ===
                            "COMISIONES"

                    ) {

                        permitido = true;

                    }

                }



                // ==================================================
                // LOGISTICA
                //
                // PERMITIDO:
                //
                // - HORAS EXTRAS
                // - HORAS DOBLES
                // - CUMPLEAÑEROS
                // ==================================================

                if (esLogistica) {

                    if (

                        nombreNormalizado ===
                            "HORAS EXTRAS" ||

                        nombreNormalizado ===
                            "HORAS DOBLES" ||

                        nombreNormalizado ===
                            "CUMPLEAÑEROS"

                    ) {

                        permitido = true;

                    }

                }



                // ==================================================
                // ADMINISTRADOR
                //
                // NO SE BLOQUEA NADA.
                // ==================================================



                // ==================================================
                // SI ESTÁ PERMITIDO
                // ==================================================

                if (permitido) {

                    modulo.classList.remove(
                        "acceso-limitado"
                    );


                    modulo.removeAttribute(
                        "aria-disabled"
                    );


                    modulo.removeAttribute(
                        "title"
                    );


                    return;

                }



                // ==================================================
                // BLOQUEAR
                // ==================================================

                modulo.classList.add(
                    "acceso-limitado"
                );



                // ==================================================
                // GUARDAR URL ORIGINAL
                // ==================================================

                const urlOriginal =
                    modulo.getAttribute(
                        "href"
                    );


                if (urlOriginal) {

                    modulo.dataset.urlOriginal =
                        urlOriginal;

                }



                // ==================================================
                // ELIMINAR NAVEGACIÓN
                // ==================================================

                modulo.removeAttribute(
                    "href"
                );



                // ==================================================
                // CAMBIAR ICONO A CANDADO
                // ==================================================

                const iconos =
                    modulo.querySelectorAll(
                        "i"
                    );


                if (
                    iconos.length > 0
                ) {

                    iconos[0].className =
                        "bi bi-lock-fill";

                }



                // ==================================================
                // INDICADOR VISUAL
                // ==================================================

                modulo.setAttribute(
                    "aria-disabled",
                    "true"
                );


                modulo.setAttribute(
                    "title",
                    "Acceso restringido"
                );



                // ==================================================
                // BLOQUEAR CLICK
                // ==================================================

                modulo.addEventListener(
                    "click",
                    function (event) {

                        event.preventDefault();

                        event.stopPropagation();

                    }
                );

            }
        );

    }



    // ==========================================================
    // BOTÓN MENÚ RESPONSIVE
    // ==========================================================

    if (btnMenu) {

        btnMenu.addEventListener(
            "click",
            function () {

                sidebar.classList.toggle(
                    "show"
                );


                overlay.classList.toggle(
                    "show"
                );

            }
        );

    }



    // ==========================================================
    // OVERLAY
    // ==========================================================

    if (overlay) {

        overlay.addEventListener(
            "click",
            function () {

                sidebar.classList.remove(
                    "show"
                );


                overlay.classList.remove(
                    "show"
                );

            }
        );

    }



    // ==========================================================
    // SUBMENÚS
    // ==========================================================

    const menuToggles =
        document.querySelectorAll(
            ".menu-toggle"
        );


    menuToggles.forEach(
        function (toggle) {

            toggle.addEventListener(
                "click",
                function (event) {


                    // ==========================================
                    // SI EL MENÚ PADRE ESTÁ BLOQUEADO
                    // ==========================================

                    if (
                        toggle.classList.contains(
                            "acceso-limitado"
                        )
                    ) {

                        event.preventDefault();

                        event.stopPropagation();

                        return;

                    }


                    // ==========================================
                    // COMPORTAMIENTO NORMAL
                    // ==========================================

                    event.preventDefault();


                    const menuId =
                        toggle.getAttribute(
                            "href"
                        );


                    if (!menuId) {

                        return;

                    }


                    const submenu =
                        document.querySelector(
                            menuId
                        );


                    if (!submenu) {

                        return;

                    }


                    // ==========================================
                    // CERRAR OTROS SUBMENÚS
                    // ==========================================

                    document
                        .querySelectorAll(
                            ".submenu"
                        )
                        .forEach(
                            function (item) {

                                if (
                                    item !== submenu
                                ) {

                                    item.classList.remove(
                                        "show"
                                    );

                                }

                            }
                        );


                    // ==========================================
                    // QUITAR OPEN DE OTROS
                    // ==========================================

                    menuToggles.forEach(
                        function (item) {

                            if (
                                item !== toggle
                            ) {

                                item.classList.remove(
                                    "open"
                                );

                            }

                        }
                    );


                    // ==========================================
                    // ABRIR / CERRAR ACTUAL
                    // ==========================================

                    submenu.classList.toggle(
                        "show"
                    );


                    toggle.classList.toggle(
                        "open"
                    );

                }
            );

        }
    );



    // ==========================================================
    // CERRAR MENÚ EN MÓVIL
    // ==========================================================

    document
        .querySelectorAll(
            ".sidebar .nav-link"
        )
        .forEach(
            function (link) {

                link.addEventListener(
                    "click",
                    function () {


                        // ======================================
                        // NO CERRAR SI ES SUBMENÚ
                        // ======================================

                        if (
                            link.classList.contains(
                                "menu-toggle"
                            )
                        ) {

                            return;

                        }


                        // ======================================
                        // CERRAR EN MÓVIL
                        // ======================================

                        if (
                            window.innerWidth <= 991
                        ) {

                            sidebar.classList.remove(
                                "show"
                            );


                            overlay.classList.remove(
                                "show"
                            );

                        }

                    }
                );

            }
        );



    // ==========================================================
    // CERRAR SESIÓN
    // ==========================================================

    const btnCerrarSesion =
        document.getElementById(
            "btnCerrarSesion"
        );


    if (btnCerrarSesion) {

        btnCerrarSesion.addEventListener(
            "click",
            function (event) {

                event.preventDefault();


                // ==========================================
                // ELIMINAR SESIÓN LOCAL
                // ==========================================

                localStorage.removeItem(
                    "usuario"
                );


                localStorage.removeItem(
                    "token"
                );


                sessionStorage.removeItem(
                    "usuarioSesion"
                );


                // ==========================================
                // REDIRECCIÓN
                // ==========================================

                window.location.replace(
                    "/inicioSesion.html"
                );

            }
        );

    }



    // ==========================================================
    // RESIZE
    // ==========================================================

    window.addEventListener(
        "resize",
        function () {

            if (
                window.innerWidth > 991
            ) {

                sidebar.classList.remove(
                    "show"
                );


                overlay.classList.remove(
                    "show"
                );

            }

        }
    );

}